import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { configSectionsInOut } from 'animations-lib';
import { FeatureFlagService } from 'feature-flags-lib';
import { NumberFormatSeparator } from 'enums-lib';
import { DecimalFormatOptions } from 'interfaces-lib';
import { FieldConfigChangedControllerService } from '../../../../data-fields/field-config-changed-controller.service';

@Component({
    selector: 'app-format-decimal',
    templateUrl: './format-decimal.component.html',
    styleUrls: ['../format-number.component.scss', '../../field-options.component.scss'],
    animations: [configSectionsInOut],
    standalone: false
})
export class FormatDecimalComponent implements OnInit {
  @Input() set fieldOptions(fieldOptions: DecimalFormatOptions | undefined) {
    this.initFieldOptions(fieldOptions);
    this.hasChanged = false;
  }
  @Output() fieldOptionsChange = new EventEmitter<DecimalFormatOptions>();

  expanded = false;
  hasChanged = false;
  exactDecimalDigits: number | undefined;
  minimumIntegerDigits = 0;
  decimalSeparator: NumberFormatSeparator | undefined;
  thousandsSeparator: NumberFormatSeparator | undefined;
  isPercentage = false;

  readonly NumberFormatSeparator = NumberFormatSeparator;
  readonly percentageFieldEnabled = this.featureFlagService.enabled(FeatureFlagService.FLAGS.percentageNumberField);

  constructor(
    private configChangedControllerService: FieldConfigChangedControllerService,
    private featureFlagService: FeatureFlagService
  ) {}

  ngOnInit() {
    this.hasChanged = this.configChangedControllerService.get('FormatDecimalComponent');
  }

  isValid(): boolean {
    return (
      (this.minimumIntegerDigits == 0 || this.minimumIntegerDigits == 1) &&
      this.exactDecimalDigits !== undefined &&
      this.decimalSeparator !== undefined &&
      this.thousandsSeparator !== undefined
    );
  }

  getFormatOption(): DecimalFormatOptions | undefined {
    return this.isValid()
      ? {
          minimumIntegerDigits: this.minimumIntegerDigits!,
          exactDecimalDigits: this.exactDecimalDigits!,
          thousandsSeparator: this.thousandsSeparator!,
          decimalSeparator: this.decimalSeparator!,
          isPercentage: this.isPercentage,
        }
      : undefined;
  }

  toggleExpanded() {
    this.expanded = !this.expanded;
  }

  updateConfig() {
    this.fieldOptionsChange.emit(this.getFormatOption());
    this.configChangedControllerService.update('FormatDecimalComponent', true);
    setTimeout(() => (this.hasChanged = true), 0);
  }

  private initFieldOptions(fieldOptions: DecimalFormatOptions | undefined) {
    if (fieldOptions) {
      this.minimumIntegerDigits = fieldOptions.minimumIntegerDigits;
      this.exactDecimalDigits = fieldOptions.exactDecimalDigits;
      this.decimalSeparator = fieldOptions.decimalSeparator;
      this.thousandsSeparator = fieldOptions.thousandsSeparator;
      this.isPercentage = fieldOptions.isPercentage ?? false;
    }
  }
}
